export default [
  {
    id: 1,
    title: { it: "Armadi", en: "Wardrobes" },
    subTitle: {
      it: "anta battente e pieghevole",
      en: "hinged and folding door",
    },
    products: [
      {
        sourceImage: require("./images/mainImgs/home/02a.jpg"),
        detailImage: "AntaBattenteHome",
        room: "Home",
        code: "02a",
        name: { it: "Ingresso", en: "Entrance" },
        size: {
          height: "221,3 - 239,6 - 257,9 - 294,5",
          widths: "42,5 - 47,5 - 57,5 - 87,5 - 97,5 - 117,5",
          depths: "60,6",
        },
      },
      {
        sourceImage: require("./images/mainImgs/home/05c.jpg"),

        detailImage: "AntaBattenteHome",
        room: "Home",
        code: "05c",
        name: { it: "Soggiorno", en: "Living room" },
        size: {
          height: "221,3 - 239,6 - 257,9 - 294,5",
          widths: "42,5 - 47,5 - 57,5 - 87,5 - 97,5 - 117,5",
          depths: "60,6",
        },
      },
      {
        sourceImage: require("./images/mainImgs/home/08b.jpg"),

        detailImage: "AntaBattenteHome",
        room: "Home",
        code: "08b",
        name: { it: "Camera", en: "Bedroom" },
        size: {
          height: "221,3 - 239,6 - 257,9 - 294,5",
          widths: "42,5 - 47,5 - 57,5 - 87,5 - 97,5 - 117,5",
          depths: "60,6",
        },
      },
      {
        sourceImage: require("./images/mainImgs/home/11b.jpg"),

        detailImage: "AntaBattenteHome",
        room: "Home",
        code: "11b",
        name: { it: "Camera", en: "Bedroom" },
        size: {
          height: "221,3 - 239,6 - 257,9 - 294,5",
          widths: "42,5 - 47,5 - 57,5 - 87,5 - 97,5 - 117,5",
          depths: "60,6",
        },
      },
      {
        sourceImage: require("./images/mainImgs/public/04b.jpg"),

        detailImage: "AntaBattentePublic",
        room: "Public",
        code: "04b",
        name: { it: "Operativo", en: "Workspace" },
        size: {
          height: "221,3 - 239,6 - 257,9 - 294,5",
          widths: "42,5 - 47,5 - 57,5 - 87,5 - 97,5 - 117,5",
          depths: "60,6",
        },
      },
      {
        sourceImage: require("./images/mainImgs/public/08a.jpg"),

        detailImage: "AntaBattentePublic",
        room: "Public",
        code: "08a",
        name: { it: "Spazi comuni", en: "Common areas" },
        size: {
          height: "221,3 - 239,6 - 257,9 - 294,5",
          widths: "42,5 - 47,5 - 57,5 - 87,5 - 97,5 - 117,5",
          depths: "60,6",
        },
      },
      {
        sourceImage: require("./images/mainImgs/public/10a.jpg"),

        detailImage: "AntaBattentePublic",
        room: "Public",
        code: "10a",
        name: { it: "Camera hotel", en: "Hotel room" },
        size: {
          height: "221,3 - 239,6 - 257,9 - 294,5",
          widths: "42,5 - 47,5 - 57,5 - 87,5 - 97,5 - 117,5",
          depths: "60,6",
        },
      },
      {
        sourceImage: require("./images/mainImgs/public/13a.jpg"),

        detailImage: "AntaBattentePublic",
        room: "Public",
        code: "13a",
        name: { it: "Aparthotel", en: "Serviced apartment" },
        size: {
          height: "221,3 - 239,6 - 257,9 - 294,5",
          widths: "42,5 - 47,5 - 57,5 - 87,5 - 97,5 - 117,5",
          depths: "60,6",
        },
      },
    ],
  },
  {
    id: 3,
    title: { it: "Armadi", en: "Wardrobes" },
    subTitle: { it: "basi armadio", en: "wardorobe base units" },
    products: [
      {
        sourceImage: require("./images/mainImgs/home/08a.jpg"),
        detailImage: "BasiHome",
        room: "Home",
        code: "08a",
        name: { it: "Camera", en: "Bedroom" },
        size: {
          height: "38,3 - 56,6 - 74,9 - 111,5",
          widths: "42,5 - 47,5 - 57,5 - 87,5 - 97,5 - 117,5",
          depths: "60,6",
          top: "1,2 - 3",
        },
      },
      {
        sourceImage: require("./images/mainImgs/home/13a.jpg"),

        detailImage: "BasiHome",
        room: "Home",
        code: "13a",
        name: { it: "Lavanderia", en: "Laundry" },
        size: {
          height: "38,3 - 56,6 - 74,9 - 111,5",
          widths: "42,5 - 47,5 - 57,5 - 87,5 - 97,5 - 117,5",
          depths: "60,6",
          top: "1,2 - 3",
        },
      },
      {
        sourceImage: require("./images/mainImgs/public/05a2.jpg"),

        detailImage: "BasiPublic",
        room: "Public",
        code: "05a",
        name: { it: "Operativo", en: "Workspace" },
        size: {
          height: "38,3 - 56,6 - 74,9 - 111,5",
          widths: "42,5 - 47,5 - 57,5 - 87,5 - 97,5 - 117,5",
          depths: "60,6",
          top: "1,2 - 3",
        },
      },
      {
        sourceImage: require("./images/mainImgs/public/12a.jpg"),

        detailImage: "BasiPublic",
        room: "Public",
        code: "12a",
        name: { it: "Aparthotel", en: "Serviced apartment" },
        size: {
          height: "38,3 - 56,6 - 74,9 - 111,5",
          widths: "42,5 - 47,5 - 57,5 - 87,5 - 97,5 - 117,5",
          depths: "60,6",
          top: "1,2 - 3",
        },
      },
    ],
  },
  {
    id: 2,
    title: { it: "Armadi", en: "Wardrobes" },
    subTitle: { it: "Service", en: "Service" },
    products: [
      {
        sourceImage: require("./images/mainImgs/home/14b.jpg"),
        detailImage: "ServicePublic",
        room: "Home",
        code: "14b",
        name: { it: "Lavanderia", en: "Laundry" },
        size: {
          height: "221,3 - 239,6 - 257,9 - 294,5",
          widths: "72,5 - 87,5 - 97,5 - 117,5",
          depths: "72,4",
        },
      },
      {
        sourceImage: require("./images/mainImgs/home/14b2.jpg"),
        detailImage: "ServicePublic",
        room: "Home",
        code: "14b",
        name: { it: "Lavanderia", en: "Laundry" },
        size: {
          height: "221,3 - 239,6 - 257,9 - 294,5",
          widths: "72,5 - 87,5 - 97,5 - 117,5",
          depths: "72,4",
        },
      },
    ],
  },
  {
    id: 4,
    title: { it: "Armadi", en: "Wardrobes" },
    subTitle: { it: "ponti", en: "bridging units" },
    products: [
      {
        sourceImage: require("./images/mainImgs/home/04a.jpg"),
        detailImage: "PontiHome",
        room: "Home",
        code: "04a",
        name: { it: "Soggiorno", en: "Living room" },
        size: {
          height: "221,3 - 239,6 - 257,9 - 294,5",
          widths: "117,5 - 147,5 - 177,5 - 207,5 - 217,5 - 237,5",
          depths: "60,6",
        },
      },
      {
        sourceImage: require("./images/mainImgs/home/08d.jpg"),

        detailImage: "PontiHome",
        room: "Home",
        code: "08d",
        name: { it: "Camera", en: "Bedroom" },
        size: {
          height: "221,3 - 239,6 - 257,9 - 294,5",
          widths: "117,5 - 147,5 - 177,5 - 207,5 - 217,5 - 237,5",
          depths: "60,6",
        },
      },
      {
        sourceImage: require("./images/mainImgs/home/09a.jpg"),

        detailImage: "PontiHome",
        room: "Home",
        code: "09a",
        name: { it: "Camera", en: "Bedroom" },
        size: {
          height: "221,3 - 239,6 - 257,9 - 294,5",
          widths: "117,5 - 147,5 - 177,5 - 207,5 - 217,5 - 237,5",
          depths: "60,6",
        },
      },
      {
        sourceImage: require("./images/mainImgs/home/16a.jpg"),

        detailImage: "PontiHome",
        room: "Home",
        code: "16a",
        name: { it: "Garage", en: "Garage" },
        size: {
          height: "221,3 - 239,6 - 257,9 - 294,5",
          widths: "117,5 - 147,5 - 177,5 - 207,5 - 217,5 - 237,5",
          depths: "60,6",
        },
      },
      {
        sourceImage: require("./images/mainImgs/public/02a.jpg"),

        detailImage: "PontiPublic",
        room: "Public",
        code: "02a",
        name: { it: "Direzionale", en: "Executive space" },
        size: {
          height: "221,3 - 239,6 - 257,9 - 294,5",
          widths: "117,5 - 147,5 - 177,5 - 207,5 - 217,5 - 237,5",
          depths: "60,6",
        },
      },
      {
        sourceImage: require("./images/mainImgs/public/05a.jpg"),

        detailImage: "PontiPublic",
        room: "Public",
        code: "05a",
        name: { it: "Operativo", en: "Workspace" },
        size: {
          height: "221,3 - 239,6 - 257,9 - 294,5",
          widths: "117,5 - 147,5 - 177,5 - 207,5 - 217,5 - 237,5",
          depths: "60,6",
        },
      },
    ],
  },
  {
    id: 5,
    title: { it: "Armadi", en: "Wardrobes" },
    subTitle: { it: "anta scorrevole", en: "sliding door" },
    products: [
      {
        sourceImage: require("./images/mainImgs/home/08c.jpg"),
        detailImage: "ScorrevoliHome",
        room: "Home",
        code: "08c",
        name: { it: "Camera", en: "Bedroom" },
        size: {
          height: "221,3 - 239,6 - 257,9",
          widths: "72,5 - 87,5 - 97,5",
          depths: "64,2 - 66,3 - 67,5",
        },
      },
      {
        sourceImage: require("./images/mainImgs/home/08e.jpg"),
        detailImage: "ScorrevoliHome",
        room: "Home",
        code: "08e",
        name: { it: "Camera", en: "Bedroom" },
        size: {
          height: "221,3 - 239,6 - 257,9",
          widths: "72,5 - 87,5 - 97,5",
          depths: "64,2 - 66,3 - 67,5",
        },
      },
      {
        sourceImage: require("./images/mainImgs/home/11c.jpg"),
        detailImage: "ScorrevoliHome",
        room: "Home",
        code: "11c",
        name: { it: "Camera", en: "Bedroom" },
        size: {
          height: "221,3 - 239,6 - 257,9",
          widths: "72,5 - 87,5 - 97,5",
          depths: "64,2 - 66,3 - 67,5",
        },
      },
      {
        sourceImage: require("./images/mainImgs/home/16c.jpg"),

        detailImage: "ScorrevoliHome",
        room: "Home",
        code: "16c",
        name: { it: "Garage", en: "Garage" },
        size: {
          height: "221,3 - 239,6 - 257,9",
          widths: "72,5 - 87,5 - 97,5",
          depths: "64,2 - 66,3 - 67,5",
        },
      },
      {
        sourceImage: require("./images/mainImgs/public/06b.jpg"),

        detailImage: "ScorrevoliPublic",
        room: "Public",
        code: "06b",
        name: { it: "Open space", en: "Open-plan layout" },
        size: {
          height: "221,3 - 239,6 - 257,9",
          widths: "72,5 - 87,5 - 97,5",
          depths: "64,2 - 66,3 - 67,5",
        },
      },
      {
        sourceImage: require("./images/mainImgs/public/11c.jpg"),

        detailImage: "ScorrevoliPublic",
        room: "Public",
        code: "11c",
        name: { it: "Camera hotel", en: "Hotel room" },
        size: {
          height: "221,3 - 239,6 - 257,9",
          widths: "72,5 - 87,5 - 97,5",
          depths: "64,2 - 66,3 - 67,5",
        },
      },
      {
        sourceImage: require("./images/mainImgs/public/12b.jpg"),

        detailImage: "ScorrevoliPublic",
        room: "Public",
        code: "12b",
        name: { it: "Aparthotel", en: "Serviced apartment" },
        size: {
          height: "221,3 - 239,6 - 257,9",
          widths: "72,5 - 87,5 - 97,5",
          depths: "64,2 - 66,3 - 67,5",
        },
      },
    ],
  },
];
